import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full pointer-events-auto flex items-center justify-end" }
const _hoisted_2 = { class: "pr-3 flex justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-ellipsis-h text-[20px] text-Text/text_high !mr-0" }, null, -1)

import { useAgentActionsMenu } from '@/components/agents-table/AgentActionsMenu.helpers';
import { Agent, License_RegisterAgentAction } from '@/graphql/codegen/generated/graphql';
import { IncrediButton } from 'incredi-ui';
import AgentActionMenu from '@/components/agents-table/AgentActionMenu.vue';
import { computed, inject, ref } from 'vue';
import { useDialogPresets } from '@/services/dialogPresets.composable';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { useStore } from 'vuex';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { IKAgentsPersistentData } from '@/views/agents/agents.injectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsTableFloatingCell',
  props: {
    agent: null
  },
  emits: ["toggleRow"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'toggleRow', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  agent: Agent | null | undefined;
}

const userRolePermissions = useUserRolePermissions();
const store = useStore();
const platformAuthentication = inject(IKPlatformAuthentication);
const agentsPersistedData = inject(IKAgentsPersistentData);
const agentsActions = useAgentActionsMenu(platformAuthentication?.osType.value || OsType.Windows);
const curActiveAgentMenu = ref<null | Agent>(null);


const isWindowsOS = computed(() => platformAuthentication?.osType.value === OsType.Windows);

const isCompactRow = computed(() => agentsPersistedData?.getAgentsTableCompactView.value || false);

const type = computed<false | 'Update' | 'Resolve'>(() => {
  if (props.agent?.metadata?.isValidForVersionUpdate) return 'Update';
  if (props.agent?.metadata?.isDuplicateLicense) return 'Resolve';
  return false;
});
const { dialogPresets } = useDialogPresets();
const handleOpenContextMenu = () => {
  if (props.agent) {
    emit('toggleRow', true);
    curActiveAgentMenu.value = props.agent;
  }
};

const handleClick = () => {
  if (type.value === 'Resolve' && props.agent)
    dialogPresets.value.resolveAgentsDialog(() => (props.agent ? agentsActions.setRemoveAgentLicense([props.agent], License_RegisterAgentAction.Resolve) : null));
  else if (type.value === 'Update' && props.agent) agentsActions.setUpdateVersion([props.agent]);
};

const isAgentRowHoverStyleActive = (agent: Agent) =>
  curActiveAgentMenu.value === agent.name || !curActiveAgentMenu.value || store.getters['agents/getAgentsLocked'][agent?.name || ''] || agent.metadata?.isDuplicateLicense;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["pl-6", _unref(isCompactRow) ? 'h-[32px]' : 'h-[46px]'])
    }, null, 2),
    (!__props.agent?.metadata?.isInProgress)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex items-center", _unref(isCompactRow) ? 'h-[32px]' : 'h-[46px]'])
        }, [
          (_unref(type) && _unref(isWindowsOS))
            ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                key: 0,
                class: _normalizeClass([props.agent?.metadata?.isDuplicateLicense ? 'pr-0' : 'pr-4']),
                size: "small",
                design: "primary-red",
                onClick: handleClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(type)), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_unref(userRolePermissions).authorize?.value?.agents.enabled.actions && !props.agent?.metadata?.isDuplicateLicense)
              ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                  key: 0,
                  design: "ghost-grey",
                  fab: "",
                  class: "flex w-[32px] h-[32px] items-center justify-center transition-all !duration-[200ms]",
                  size: 'small',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOpenContextMenu()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(AgentActionMenu, {
              agent: curActiveAgentMenu.value || {},
              "agent-row-hover-state": curActiveAgentMenu.value ? isAgentRowHoverStyleActive(curActiveAgentMenu.value) : undefined,
              offset: [6, 3],
              "agent-name": curActiveAgentMenu.value?.name,
              "before-hide": 
            () => {
              curActiveAgentMenu.value = null;
              emit('toggleRow', false);
            }
          
            }, null, 8, ["agent", "agent-row-hover-state", "agent-name", "before-hide"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})